import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles({
  rootContainer: {
    position: "fixed",
     top: 0, // Position at the top of the viewport
    left: 0, // Position at the left of the viewport
    bottom: 0, // Extend to the bottom of the viewport
    color: "#19334e",
    background: 'rgba(255, 255, 255, 0.5)', // Translucent white
    backdropFilter: 'blur(10px)', // Blur effect
    borderRadius: '10px', // Rounded corners
    boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)', // Optional shadow for depth

    textAlign: "center",
    width: "200px",
    transition: "width 0.3s ease-in-out",

    overflowY: "auto", // Enable vertical scrolling if the content exceeds the viewport height

  },
  rootContainerCollapsed: {
    width: "0",
  },
  closeContainer: {
    textAlign: "right",
  },
  linkContainer: {
    marginTop: 10,
  },
  closeButton: {
    textAlign: "right",
    color: "black",
  },
  footerContainer: {
    marginBottom: 20,
    display: "block",
  },
 
  link: {
    color: "#19334e",
    "&:hover": {
      color: "#39a3e3",
    },
    marginLeft: "5%",
  },
  linkIcon: {
    marginRight: 10,
  },

});
